// extracted by mini-css-extract-plugin
export default {"home":"Home_home__38vP9","inner":"Home_inner__MnzWi","result":"Home_result__C2VTE","resbox":"Home_resbox__Sw6vU","btns":"Home_btns__nUxqz"};